import { SectionCard } from '../components';
import { styled } from '@ltvco/refresh-lib/theme';

export const OfferCard = styled(SectionCard)(({ theme }) => ({
  border: `2px solid ${theme.palette.error.main}`,
  borderRadius: 10,
  padding: theme.spacing(2),
  marginBottom: 0,
}));
